<!--
	Copyright (c) 2017-present, flop! contributors
	SPDX-License-Identifier: AGPL-3.0-or-later
	https://framagit.org/flopedt/flopedt
-->

<script setup lang="ts">
import { useUndoRedoStore } from '@/stores/undoredo.ts'

import SimpleButton from '@uikit/button/SimpleButton.vue'
import Popover from '@uikit/Popover.vue'
import UndoRedoHistory from '@/components/header/undoredo/UndoRedoHistory.vue'

import RedoIcon from '~mingcute/system/refresh_1_line.svg'
import UndoIcon from '~mingcute/system/refresh_anticlockwise_1_line.svg'

const undoredo = useUndoRedoStore()
</script>

<template>
  <div class="undoredo-controls">
    <SimpleButton class="undo" icon-button :disabled="!undoredo.canUndo" @click="undoredo.undo()">
      <UndoIcon />
    </SimpleButton>
    <SimpleButton class="redo" icon-button :disabled="!undoredo.canRedo" @click="undoredo.redo()">
      <RedoIcon />
    </SimpleButton>
    <Popover icon-button button-aria-label="History">
      <template #header>History</template>
      <UndoRedoHistory />
    </Popover>
  </div>
</template>

<style scoped>
.undoredo-controls {
  display: flex;
  gap: 0.25rem;
}

.undo {
  border-top-right-radius: var(--border-radius-small);
  border-bottom-right-radius: var(--border-radius-small);
}

.redo {
  border-top-left-radius: var(--border-radius-small);
  border-bottom-left-radius: var(--border-radius-small);
}
</style>
